import { CookieNames, getCookie } from '../helpers/cookie.helper';
import axios from './axiosConfig';

export const getProfile = async (userId) => {
    try {
        const response = await axios.get(`/api/User/MyProfile`, { params: { userId, SessionId: getCookie(CookieNames.SESSION_ID) } });
        if (response.data) {
            return response.data;
        }
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const updateProfile = async (userId, formData) => {
    try {
        const response = await axios.post(
            `/api/User/MyProfile`,
            formData,
            {
                params: { userId, SessionId: getCookie(CookieNames.SESSION_ID) },
                headers: { 'Content-Type': 'multipart/form-data' }
            }
        );
        if (response.data) {
            return response.data;
        }
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const changePassword = async (params) => {
    try {
        const response = await axios.post(`/api/User/ChangePassword`, {}, { params });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const resetPasswordBySuperAdmin = async (email, companyId) => {
    try {
        const response = await axios.get(`/api/CompanyMaster/ResetPasswordBySuperAdmin`, {
            params: {
                EmailAddress: email,
                CompanyId: companyId,
                SessionId: getCookie(CookieNames.SESSION_ID)
            }
        });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}